import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import type { CenteredSpinnerProps } from './CenteredSpinner.types';

/**
 * A reusable centered loading spinner component.
 * Centers itself within its container (not fullscreen).
 * 
 * @example
 * // Basic usage
 * <CenteredSpinner />
 * 
 * @example
 * // With message
 * <CenteredSpinner message="Loading dashboard..." />
 * 
 * @example
 * // Custom size and color
 * <CenteredSpinner size={60} color="secondary" />
 */
export const CenteredSpinner: React.FC<CenteredSpinnerProps> = ({
  size = 40,
  color = 'primary',
  message,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        gap: 2,
        ...sx,
      }}
    >
      <CircularProgress size={size} color={color} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default CenteredSpinner;